const Storage = {
    get: (key) => {
        let value = null
        const currentTime = new Date().getTime()
        try {
            value = JSON.parse(localStorage?.getItem(key))
            if (value.data?.expiry && currentTime > value.data?.expiry) {
                localStorage?.removeItem(key)
                return null
            } else if (value && Object.prototype.hasOwnProperty.call(value, "data")) {
                value = value.data
            }
        } catch (e) {
            if (localStorage?.[key]) {
                value = { data: localStorage?.getItem(key) }
                if (value.data?.expiry && currentTime > value.data?.expiry) {
                    localStorage?.removeItem(key)
                    return null
                }
            } else {
                value = null
            }
        }

        return value
    },
    set: (key, value, expiryTime = 0) => {
        try {
            // expiry time in miliseconds
            if (expiryTime) {
                localStorage?.setItem(
                    key,
                    JSON.stringify({ data: { value, expiry: new Date().getTime() + expiryTime } })
                )
            } else {
                localStorage?.setItem(key, JSON.stringify({ data: value }))
            }
        } catch (e) {
            if (console)
                console.warn(
                    "LocalStorage didn't successfully save the '{" +
                        key +
                        ": " +
                        value +
                        "}' pair, because the localStorage is full."
                )
        }
    },
    remove: (key) => {
        localStorage?.removeItem(key)
    },
    flush: () => {
        // const allKeys = Object.keys(localStorage);
        localStorage?.clear()
        // allKeys.forEach(key => {
        //     localStorage.removeItem(key);
        // });
    },
}

export default Storage
